
export default {
  VALIDATE_RESULT(state, val) {
    state.result = val;
  },
  VALIDATE_MESSAGE(state, msg) {
    state.isMsg.message = msg;
  }
};
